<template>
  <div class="order-form">
    <div class="animated fadeIn">
      <b-row>
        <b-col cols="12">
          <b-card>
            <div slot="header">
              {{$t('client.config')}}
            </div>
            <b-form class="row">
              <b-col cols="12">
                <b-form-group v-for="(option, i) in order.list" :key="i+0" v-bind:label="option.name" :label-cols="4" :horizontal="true">
                  <b-row>
                    <b-col cols="6">
                      <b-form-group v-bind:label="$t('client.display')" label-cols="3" :horizontal="true">
                        <c-switch type="icon" variant="success" v-bind="{on: '\uf00c', off: '\uf00d'}"
                                  :pill="true" v-model="order.list[i].show" :value="true" :uncheckedValue="false"/>
                      </b-form-group>
                    </b-col>
                  </b-row>
                </b-form-group>
              </b-col>
            </b-form>
          </b-card>
          <b-card>
            <div slot="header">
              {{$t('client.basic_information')}}
            </div>
            <b-form class="row">
              <b-col cols="12">
                <b-form-group v-for="(option, i) in order.basic_info" :key="i+0" v-bind:label="option.name" :label-cols="4" :horizontal="true">
                  <b-row>
                    <b-col cols="6">
                      <b-form-group v-bind:label="$t('client.display')" label-cols="3" :horizontal="true">
                        <c-switch type="icon" variant="success" v-bind="{on: '\uf00c', off: '\uf00d'}"
                                  :pill="true" v-model="order.basic_info[i].show" :value="true" :uncheckedValue="false"/>
                      </b-form-group>
                    </b-col>
                    <b-col cols="6">
                      <b-form-group v-bind:label="$t('client.disable')" label-cols="3" :horizontal="true">
                        <c-switch type="icon" variant="success" v-bind="{on: '\uf00c', off: '\uf00d'}"
                                  :pill="true" v-model="order.basic_info[i].disable" :value="true" :uncheckedValue="false"/>
                      </b-form-group>
                    </b-col>
                  </b-row>
                </b-form-group>
              </b-col>
            </b-form>
          </b-card>
          <b-card>
            <div slot="header">
              {{$t('client.config')}}
            </div>
            <b-form class="row">
              <b-col cols="12">
                <b-form-group label="Resend" label-cols="3" :horizontal="true">
                  <c-switch type="icon" variant="success" v-bind="{on: '\uf00c', off: '\uf00d'}" :pill="true" v-model="order.config.resend" :value="true" :uncheckedValue="false"/>
                </b-form-group>
                <b-form-group label="Cancel" label-cols="3" :horizontal="true">
                  <c-switch type="icon" variant="success" v-bind="{on: '\uf00c', off: '\uf00d'}" :pill="true" v-model="order.config.cancel" :value="true" :uncheckedValue="false"/>
                </b-form-group>
                <b-form-group label="Complete" label-cols="3" :horizontal="true">
                  <c-switch type="icon" variant="success" v-bind="{on: '\uf00c', off: '\uf00d'}" :pill="true" v-model="order.config.complete" :value="true" :uncheckedValue="false"/>
                </b-form-group>
                <b-form-group label="Proceed" label-cols="3" :horizontal="true">
                  <c-switch type="icon" variant="success" v-bind="{on: '\uf00c', off: '\uf00d'}" :pill="true" v-model="order.config.proceed" :value="true" :uncheckedValue="false"/>
                </b-form-group>
                <b-form-group label="Error Orders" label-cols="3" :horizontal="true">
                  <c-switch type="icon" variant="success" v-bind="{on: '\uf00c', off: '\uf00d'}" :pill="true" v-model="order.config.error_order" :value="true" :uncheckedValue="false"/>
                </b-form-group>
                <b-form-group label="Pending Orders" label-cols="3" :horizontal="true">
                  <c-switch type="icon" variant="success" v-bind="{on: '\uf00c', off: '\uf00d'}" :pill="true" v-model="order.config.pending_order" :value="true" :uncheckedValue="false"/>
                </b-form-group>
                <b-form-group label="Resend Mail" label-cols="3" :horizontal="true">
                  <c-switch type="icon" variant="success" v-bind="{on: '\uf00c', off: '\uf00d'}" :pill="true" v-model="order.config.resend_mail" :value="true" :uncheckedValue="false"/>
                </b-form-group>
                <b-form-group label="Payment Log" label-cols="3" :horizontal="true">
                  <c-switch type="icon" variant="success" v-bind="{on: '\uf00c', off: '\uf00d'}" :pill="true" v-model="order.config.payment_log" :value="true" :uncheckedValue="false"/>
                </b-form-group>
                <b-form-group label="POS Error Response" label-cols="3" :horizontal="true">
                  <c-switch type="icon" variant="success" v-bind="{on: '\uf00c', off: '\uf00d'}" :pill="true" v-model="order.config.pos_error_response" :value="true" :uncheckedValue="false"/>
                </b-form-group>
              </b-col>
            </b-form>
          </b-card>
          <b-card>
            <div slot="header">
              {{$t('client.customization')}}
            </div>
            <b-form class="row">
              <b-col cols="12">
                <customization v-model="order.fields" :position_fields="position_fields"></customization>
              </b-col>
            </b-form>
          </b-card>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
  import cSwitch from '../../../components/Switch'
  import Customization from './Customization'

  export default {
    name: 'OrderForm',
    props: {
      value: {
        type: Object
      }
    },
    components: {
      Customization,
      cSwitch
    },
    data: function () {
      return {
        position_fields: [
          'name_seo'
        ],
        order: {
          basic_info: [
            {
              'name': 'Order Number',
              'type': 'order_number',
              'show': true,
              'disable': true
            },
            {
              'name': 'External order ID',
              'type': 'external_order_id',
              'show': true,
              'disable': true
            },
            {
              'name': 'Order Status',
              'type': 'order_status',
              'show': true,
              'disable': true
            },
            {
              'name': 'Customer Name',
              'type': 'customer_name',
              'show': true,
              'disable': true
            },
            {
              'name': 'Address',
              'type': 'street_address',
              'show': true,
              'disable': true
            },
            {
              'name': 'Customer Phone',
              'type': 'phone',
              'show': true,
              'disable': true
            },
            {
              'name': 'Customer Email',
              'type': 'email',
              'show': true,
              'disable': true
            },
            {
              'name': 'Store',
              'type': 'outlet_name',
              'show': true,
              'disable': true
            },
            {
              'name': 'Customer ID',
              'type': 'member_id',
              'show': true,
              'disable': true
            },
            {
              'name': 'Sale Channel',
              'type': 'channel',
              'show': true,
              'disable': true
            },
            {
              'name': 'Order Type',
              'type': 'order_type',
              'show': true,
              'disable': true
            },
            {
              'name': 'created_at',
              'type': 'Created At',
              'show': true,
              'disable': true
            },
            {
              'name': 'Waiting Time',
              'type': 'waiting_time_reservation_date_time',
              'show': true,
              'disable': true
            },
            {
              'name': 'Payment method',
              'type': 'payment_method',
              'show': true,
              'disable': true
            },
            {
              'name': 'Send this order as a gift',
              'type': 'gift',
              'show': true,
              'disable': true
            },  
            {
              'name': 'Note',
              'type': 'order_note',
              'show': true,
              'disable': true
            },
            {
              'name': 'Total',
              'type': 'total_order_amount',
              'show': true,
              'disable': true
            },
            {
              'name': 'Discount',
              'type': 'discount_amount',
              'show': true,
              'disable': true
            },
            {
              'name': 'Payment Credit Cart',
              'type': 'payment_credit_cart',
              'show': true,
              'disable': true
            },
            {
              'name': 'Payment Cash',
              'type': 'payment_cash',
              'show': true,
              'disable': true
            },
            {
              'name': 'Usage Point',
              'type': 'usage_point',
              'show': true,
              'disable': true
            },
            {
              'name': 'Confirmation Email Sent Time',
              'type': 'order_confirmation_email_sent_time',
              'show': true,
              'disable': true
            },
            {
              'name': 'Complete Email Sent Time',
              'type': 'order_completed_email_sent_time',
              'show': true,
              'disable': true
            },
            {
              'name': 'IP Address',
              'type': 'order_ip_address',
              'show': true,
              'disable': true
            },
            {
              'name': 'User Agent',
              'type': 'order_user_agent',
              'show': true,
              'disable': true
            },
            {
              'name': 'POS Response Status',
              'type': 'pos_response_status',
              'show': true,
              'disable': true
            },
            {
              'name': 'Credit Response Status',
              'type': 'credit_response_status',
              'show': true,
              'disable': true
            },
            {
              'name': 'Advance Order',
              'type': 'advance_order',
              'show': true,
              'disable': true
            }
          ],
          list: [
            {
              'name': 'Order Reference',
              'type': 'order_reference',
              'show': true
            },
            {
              'name': 'Customer Detail',
              'type': 'customer_detail',
              'show': true
            },
            {
              'name': 'Payment Method',
              'type': 'payment_method',
              'show': true
            },
            {
              'name': 'Order Status',
              'type': 'order_status',
              'show': true
            },
            {
              'name': 'Order Number',
              'type': 'order_number',
              'show': true
            },
            {
              'name': 'Customer Name',
              'type': 'name',
              'show': true
            },
            {
              'name': 'Customer Phone',
              'type': 'phone',
              'show': true
            },
            {
              'name': 'Store Name',
              'type': 'outlet_name',
              'show': true
            },
            {
              'name': 'Order Type',
              'type': 'order_type',
              'show': true
            },
            {
              'name': 'Sale Channel',
              'type': 'channel',
              'show': true
            },
            {
              'name': 'Send this order as a gift',
              'type': 'gift',
              'show': true
            },
            {
              'name': 'Store & Delivery Address',
              'type': 'store_delivery_address',
              'show': true
            },
            {
              'name': 'EIOS Sending Log',
              'type': 'eios_sending_log',
              'show': true
            },
            {
              'name': 'POS Error Response',
              'type': 'pos_error_response',
              'show': false
            },
            {
              'name': 'Total',
              'type': 'total',
              'show': true
            },
            {
              'name': 'Created At',
              'type': 'created_at',
              'show': true
            },
            {
              'name': 'Collection Time',
              'type': 'collection_time',
              'show': true
            },
            {
              'name': 'Assigned',
              'type': 'assigned',
              'show': true
            },
            {
              'name': 'Process Button',
              'type': 'process_button',
              'show': true
            },
            {
              'name': 'Cancel Button',
              'type': 'cancel_button',
              'show': true
            },
            {
              'name': 'Resend EIOS',
              'type': 'resend_eios',
              'show': true
            },
            {
              'name': 'Create Manually',
              'type': 'create_manually',
              'show': true
            },
            {
              'name': 'Payment Status',
              'type': 'payment_status',
              'show': true
            },
            {
              'name': 'Processing',
              'type': 'processing',
              'show': true
            },
            {
              'name': 'Address',
              'type': 'street_address',
              'show': true
            },
            {
              'name': 'Customer Email',
              'type': 'email',
              'show': true
            },
            {
              'name': 'Advance Order',
              'type': 'advance_order',
              'show': true
            },
            {
              'name': 'Pwd Id',
              'type': 'pwd_id',
              'show': true
            },
            {
              'name': 'Senior Citizen Id',
              'type': 'senior_citizen_id',
              'show': true
            },
            {
              'name': 'Processed At',
              'type': 'processed_at',
              'show': true
            },
            {
              'name': 'Color Label Advance Order',
              'type': 'color_label_advance_order',
              'show': false
            },
            {
              'name': 'Show Late Delivery',
              'type': 'show_late_delivery',
              'show': false
            },
            {
              'name': 'Show JP Gift Card',
              'type': 'show_jp_gift_card',
              'show': false
            }
          ],
          config: {
            resend: true,
            cancel: true,
            complete: true,
            proceed: true,
            error_order: false,
            pending_order: false,
            resend_mail: false,
            payment_log: false,
            pos_error_response: false,
            send_pos: false
          },
          fields: []
        }
      }
    },
    methods: {
      updateData () {
        // Update Base Info
        if (this.value != null && this.value.basic_info != null) {
          let basicInfo = {}
          for (let i in this.value.basic_info) {
            basicInfo[this.value.basic_info[i].type] = {
              show: this.value.basic_info[i].show,
              disable: this.value.basic_info[i].disable
            }
          }

          for (let i in this.order.basic_info) {
            if (basicInfo[this.order.basic_info[i].type] != null) {
              this.order.basic_info[i].show = basicInfo[this.order.basic_info[i].type].show
              this.order.basic_info[i].disable = basicInfo[this.order.basic_info[i].type].disable
            }
          }
        }

        // Update List Info
        if (this.value != null && this.value.list != null) {
          let basicInfo = {}
          for (let i in this.value.list) {
            basicInfo[this.value.list[i].type] = {
              show: this.value.list[i].show,
              disable: this.value.list[i].disable
            }
          }

          for (let i in this.order.list) {
            if (basicInfo[this.order.list[i].type] != null) {
              this.order.list[i].show = basicInfo[this.order.list[i].type].show
              this.order.list[i].disable = basicInfo[this.order.list[i].type].disable
            }
          }
        }

        // Update Config
        if (this.value != null && this.value.config != null) {
          for (let i in this.order.config) {
            if (this.value.config[i] != null) {
              this.order.config[i] = this.value.config[i]
            }
          }
        }

        // Update customization field
        if (this.value != null && this.value.fields != null) {
          this.order.fields = this.value.fields
        }
      }
    },
    created: function () {
    },
    mounted: function () {
      this.updateData()
    },
    watch: {
      order: {
        handler: function (newValue) {
          this.$emit('input', this.order)
          this.$emit('change', this.order)
        },
        deep: true
      },
      value: {
        handler: function (newValue) {
          this.updateData()
        },
        deep: true
      }
    }
  }
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/admin/client/OrderForm.vue